import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ProgramsPage from "./pages/ProgramsPage";
import ContactPage from "./pages/ContactPage";
import ApplicationPage from "./pages/ApplicationPage";
import TestimonialsPage from "./pages/TestimonialsPage";
import AdminPage from "./pages/AdminPage";
import PrivacyPage from "./pages/PrivacyPage";
import { Toaster } from "./components/ui/sonner";
import { FrameGuard } from "./components/FrameGuard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Admin — standalone, no public site chrome */}
          <Route path="/admin" element={<FrameGuard><AdminPage /><Toaster richColors position="top-center" /></FrameGuard>} />
          {/* Public site */}
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/programs" element={<ProgramsPage />} />
            <Route path="/testimonials" element={<TestimonialsPage />} />
            <Route path="/apply" element={<ApplicationPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="*" element={<HomePage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
